// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"6fc2bdc0617142ae","2741":"653c787f2490dc24","9260":"39c8b616348dfbc9","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};